import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/opt/buildhome/repo/src/components/auth/forgot-password-form.tsx");
